import { render, staticRenderFns } from "./SimpleGallery.vue?vue&type=template&id=008c5540&"
import script from "./SimpleGallery.vue?vue&type=script&lang=js&"
export * from "./SimpleGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('008c5540')) {
      api.createRecord('008c5540', component.options)
    } else {
      api.reload('008c5540', component.options)
    }
    module.hot.accept("./SimpleGallery.vue?vue&type=template&id=008c5540&", function () {
      api.rerender('008c5540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SimpleGallery.vue"
export default component.exports